import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  useDrawer
} from 'components/pcc-components';
import { CatTextLink } from 'blocks-nextjs/blocks-react/components/TextLink';
import { CatIconInfo } from 'blocks-nextjs/blocks-react/components/Icons/Info';
import { useTranslations } from 'next-intl';
import styles from './discount-price.module.scss';
import cx from 'classnames';

const CoreDepositMobileDrawer = () => {
  const t = useTranslations();
  const { closeDrawer, drawerProps, openDrawer } = useDrawer();
  const DPMobileDrawerProps = {
    closeDrawer,
    ...drawerProps
  };

  return (
    <>
      <CatTextLink
        size="sm"
        onClick={openDrawer}
        className="cat-u-theme-typography-footnote"
        data-testid="core-deposit-mobile-drawer-trigger"
      >
        <span className="text-end">{t('CAT_CORE_DEPOSIT_TITLE')}</span>
        <span className="ps-1 pt-1">
          <CatIconInfo />
        </span>
      </CatTextLink>
      <Drawer
        {...DPMobileDrawerProps}
        orientation="bottom"
        verticalMaxHeight="large"
        className={styles['core-deposit__mobile-drawer']}
      >
        <DrawerHeader>
          <h4
            className={cx(
              'cat-u-theme-typography-title-sm m-0 u-color--Black '
            )}
          >
            {t('CAT_CORE_DEPOSIT_TITLE')}
          </h4>
        </DrawerHeader>
        <DrawerBody>
          <p
            className={cx(
              styles['core-deposit__mobile-drawer__body-text'],
              'cat-u-theme-typography-body-sm m-0'
            )}
          >
            {t('CAT_CORE_UNIT_SELL')}
          </p>
        </DrawerBody>
      </Drawer>
    </>
  );
};

export default CoreDepositMobileDrawer;
